<template>
    <transition name="modal-fade">
        <div class="modal-backdrop">
            <div class="modal width500" role="dialog" aria-labelledby="modalTitle" aria-describedby="modalDescription">
                <header class="modal-header" id="modalTitle">
                    <slot name="header">
                        Nouvelle conversation
                    </slot>
                    <button type="button" class="btn-close" @click="close" aria-label="Close modal">
                        X
                    </button>
                </header>

                <section class="modal-body" id="modalDescription">
                    <slot name="body">
                        <div>
                            <div class="text-align-center" v-if="loader === true">
                                <loader></loader>
                            </div>
                            <span v-else>
                                <div v-if="erreur == ''">
                                    <v-form id="formConversationNouveau">
                                        <v-row>
                                            <v-col cols="12">
                                                <div class="field">
                                                    <label class="label">Objet du ticket</label>
                                                    <v-autocomplete v-model="body.objetTicket" item-text="lang00"
                                                        item-value="id" :items="$storeContact.Objet" outlined
                                                        dense></v-autocomplete>
                                                </div>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col cols="12">
                                                <div class="field">
                                                    <label class="label">Sujet</label>
                                                    <input type="text" class="input" maxlength="100"
                                                        v-model="body.objet" />
                                                </div>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col cols="12">
                                                <div class="field">
                                                    <label class="label">Message</label>
                                                    <textarea class="input" v-model="body.message.message"></textarea>
                                                </div>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col cols="12">
                                                <v-file-input @change="selectFile"
                                                    accept="image/jpg, image/jpeg, image/png, application/pdf"
                                                    label="Choisir un fichier (pdf, jpg, jpeg, png)" :show-size="1000"
                                                    :rules="rules">
                                                </v-file-input>
                                            </v-col>
                                        </v-row>
                                        <v-row v-if="afficherCaptcha">
                                            <v-col>
                                                <VueRecaptcha ref="recaptcha1" :sitekey="cle"
                                                    :load-recaptcha-script="true" @verify="handleSuccess"
                                                    @error="handleError" @expired="onCaptchaExpired" />
                                            </v-col>
                                        </v-row>
                                        <v-row v-if="!afficherCaptcha || validCaptcha">
                                            <v-col cols="6">
                                                <v-btn @click.native="close()">Annuler</v-btn>
                                            </v-col>
                                            <v-col cols="6">
                                                <div class="alignRight">
                                                    <v-btn @click.native="ajoutConversation()"
                                                        class="btnValider">Ajouter</v-btn>
                                                </div>
                                            </v-col>
                                        </v-row>
                                        <v-row v-if="obligatoire">
                                            <v-col cols="12">
                                                <div class="center">
                                                    <span class="spanObligatoire">Vous devez renseigner toutes les
                                                        rubriques</span>
                                                </div>
                                            </v-col>
                                        </v-row>
                                    </v-form>
                                </div>
                                <!--Message d'erreur si le cas se présente-->
                                <div id="divErreur" v-else>
                                    {{this.erreur}}
                                </div>
                            </span>
                        </div>
                    </slot>
                </section>
            </div>
        </div>

    </transition>
</template>

<script>
    import VueRecaptcha from 'vue-recaptcha'
    import Loader from "@/components/Loader.vue";

    export default {
        components: {
            Loader,
            VueRecaptcha
        },
        data() {
            return {
                cle: process.env.VUE_APP_CAPTCHA,
                afficherCaptcha: !process.env.VUE_APP_DISABLE_CAPTCHA,
                validCaptcha: false,
                rules: [
                    value => !value || value.size < 3000000 || 'La taille du fichier ne doit pas dépasser 3 MB !',
                    value => !value || value.type == 'application/pdf' || value.type == 'image/jpeg' || value.type == 'image/jpg' || value.type == 'image/png' || 'Le type du fichier non pris en charge !',
                ],
                token: '',
                loader: true,
                obligatoire: false,
                id: '',
                erreur: '',
                body: {
                    objetTicket:null,
                    objet: '',
                    message:{
                        message: null,
                        file: {
                            nomFichier: null,
                            typeFichier: null,
                            donneePieceJointe: null,
                            tailleFichier: 0,
                        }
                    },
                },
            }
        },
        mounted() {
            if(this.$route.query.token)
            {
                this.token = decodeURIComponent(this.$route.query.token.replace(/\+/g, " ")).replace(/ /g, "+");
            }
            // Si le captcha n'est pas affiché (environnement test), valider automatiquement
            if (!this.afficherCaptcha) {
                this.validCaptcha = true;
            }
            this.loader = false;
        },
    methods: {
        onCaptchaExpired() {
            this.$refs.recaptcha1.reset();
            this.validCaptcha = false;
        },
        handleSuccess() {
            this.validCaptcha = true;
        },
        handleError() {
            this.validCaptcha = false;
        },
        selectFile(file) {
            if (file) {
                this.body.message.file.nomFichier = file.name;
                this.body.message.file.typeFichier = file.type;
                this.readFile(file, this.body.message.file);
                this.body.message.file.tailleFichier = file.size;
            }
            else {
                this.body.message.file.nomFichier = null;
                this.body.message.file.typeFichier = null;
                this.body.message.file.tailleFichier = null;
                this.body.message.file.donneePieceJointe = null;
            }
        },
        // Lire le contenu d'un fichier la data de l'élément en cours
        readFile(file, monFichier) {
            var reader = new FileReader();

            // Listener de fin de lecture
            reader.onloadend = function () {
                // Recupérer la chaine lise dans le data de l'élément en cours
                monFichier.donneePieceJointe = btoa(reader.result);
            }

            // Lancer la lecture du ficheir
            reader.readAsBinaryString(file);
        },
        ajoutConversation() {
            if (this.body.objetTicket &&this.body.objet && this.body.message.message) {
                this.obligatoire = false;
                this.loader = true;
                
                this.$storeContact.AjoutConversation(this.token, this.body)
                    .then(response => {
                        this.loader = false;

                        if (response.status == 200) {
                            if (response.data.error != null) {
                                this.erreur = response.data.error;
                            }
                            else {
                                this.id = response.data.id;
                                
                                this.close();
                            }
                        }
                        else {
                            this.erreur = "Aucune donnée correspondante n'a été récupérée.";
                        }
                    })
                    .catch(error => {
                        this.loader = false;
                        this.erreur = "Une erreur est survenue lors de la tentative de récupération des données.";
                        console.log(error);
                    });
            }
            else {
                this.obligatoire = true;
            }
        },

        close() {
            // Reset l'objet
            this.body = {
                objet: '',
                objetTicket : null,
                message: {
                    message: null,
                    file: {
                        nomFichier: null,
                        typeFichier: null,
                        donneePieceJointe: null,
                        tailleFichier: 0,
                    }
                },
            };
            this.obligatoire = false;
            this.$emit('close', { id: this.id });
        }
        }
    };
</script>

<style scoped>
    @import "../../assets/css/Messagerie.css";
    @import "../../assets/css/modal.css";
</style>